
//  Stimulus controller imports and register
//      [index.js]

import { Application } from "@hotwired/stimulus";

window.Stimulus ||= Application.start();





